<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="业务回调配置">
            <a-button slot="extra" type="primary" @click="handleNewDispatch">新建配置</a-button>
            <a-form layout="inline" @submit="queryDispatch" :form="form">
                <a-form-item label="系统编码">
                     <AppAutoComplete ref="invokeappcodeASearch" @onAppCodeChange="handleSearchAppcodeChange"></AppAutoComplete>
                </a-form-item>
                <a-form-item label="关键词">
                    <a-input v-model="searchP.keyword" placeholder="请输入关键词"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="queryDispatch">
                        搜索
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <a-table :columns="columns" :data-source="tableData" :pagination="false" :loading="tLoading" :scroll="{ x: clientWidth}"
                 rowKey="id">
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span> <router-link :to="{ path:'editdispatch', query: { id: record.id}}">编辑</router-link></span>
                    <a-button type="link" style="margin-left:12px" @click="handleDel(record.id)">删除</a-button>

                </div>
            </template>

        </a-table>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />



    </div>
</template>
<script>
let pagination={
    total:0,
    pageSize:0,
    page:1,
}
const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '系统编码',
        dataIndex: 'invokeappcode',
        align: 'left',
        width: 120,
    },
    {
        title: '业务类型',
        dataIndex: 'businesstype',
        align: 'left',
        width: 120,
    },
    {
        title: '请求地址',
        dataIndex: 'resturl',
        align: 'center',
        width: 180,
        ellipsises: true
    },
    {
        title: '请求方式',
        dataIndex: 'requestmode',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '数据类型',
        dataIndex: 'requestformat',
        align: 'center',
        width: 120,
        ellipsises: true
    },
    {
        title: '返回字符集',
        dataIndex: 'outputcharset',
        align: 'center',
        width: 180,
        ellipsises: true
    },
    // {
    //     title: '请求头-json格式',
    //     dataIndex: 'requestheaders',
    //     width: 180,
    //     ellipsises: true
    // },
    {
        title: '备注',
        dataIndex: 'remark',
        align: 'center',
        width: 180,
        ellipsises: true
    },

    {
        title: "操作",
        width: 100,
        scopedSlots: {customRender: 'operation'},
        align: "center",
        ellipsis: true,
    },
];
import AppAutoComplete from '@/components/AppAutoComplete'

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            pagination,
            clientWidth:800,
            searchP: {
                invokeappcode:'',
                keyword:'',
            },
            tableData:[],
            tLoading: false,
        };
    },
    methods: {
        handleSearchAppcodeChange(value){
            this.searchP.invokeappcode = value;
        },
        handleConfirmOk() {
            this.searchMqInfoAndResendMessage();
            this.confirmVisible = false;
        },
        queryDispatch() {
            let c_params = {
                ...this.searchP,
                ...pagination,
                urlparams: false,
            }
            this.$store.dispatch({
                type: "open/dispatchQueryPageList",
                params: c_params
            }).then((res) => {
                console.log(res);
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page)
                }
                this.tLoading = false;
                
            })
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p;
            this.queryDispatch();
        },

        handleSearchReset() {
            this.pagination.page = 1;
            this.searchP.invokeappcode='';
            this.searchP.businesstype='';
            this.searchP.resturl='';
            this.searchP.requestmode='';
            this.searchP.requestformat='';
            this.searchP.outputcharset='';
            this.$refs.invokeappcodeASearch.setInputVal('');
            this.queryDispatch();
        },
        handleNewDispatch() {
            this.$router.push({
                path: "adddispatch",
            });
        },
        handleDel(id){
            let c_params = {
                id:id,
                urlparams: false,
            }
            this.$store.dispatch({
                type: "open/dispatchDel",
                params: c_params
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    this.queryDispatch();
                }
            })
        }
    },

    components: {
        AppAutoComplete
    }
    ,
    mounted() {
        this.queryDispatch();
    }
}
;
</script>

